/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Review_ReasonInputs */

const cs_gdpr_review_reason = /** @type {(inputs: Gdpr_Review_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Důvod (povinný)`)
};

const en_gdpr_review_reason = /** @type {(inputs: Gdpr_Review_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason (required)`)
};

/**
* | output |
* | --- |
* | "Reason (required)" |
*
* @param {Gdpr_Review_ReasonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_review_reason = /** @type {((inputs?: Gdpr_Review_ReasonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Review_ReasonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_review_reason(inputs)
	return cs_gdpr_review_reason(inputs)
});